export default __webpack_public_path__ + "static/media/copy.34566150.svg";